import React from "react";

const SMSPage = () => {
  return (
    <div
      style={{
        padding: "24px",
        background: "#fff",
        minHeight: "100%",
        borderRadius: "8px",
      }}
    >
      <h1>Sms Page</h1>
    </div>
  );
};

export default SMSPage;
